<template>
  <div class="receipt-transcation-details">
    <el-button
      class="transaction-details-button"
      @click="dialogVisible = true"
    >
      {{ $t("receipt.transaction-details") }}
    </el-button>
    <el-dialog
      :title="$t('receipt.transaction-details')"
      :visible.sync="dialogVisible"
      class="transaction-details-dialog"
    >
      <div class="receipt-transcation-details-row">
        <div class="receipt-transcation-details-row-title">
          <p>{{ $t("receipt.date") }}</p>
        </div>
        <div class="receipt-transcation-details-row-value">
          <p>{{ created }}</p>
        </div>
      </div>
      <div class="receipt-transcation-details-row">
        <div class="receipt-transcation-details-row-title">
          <p>{{ $t("receipt.transactionId") }}</p>
        </div>
        <div class="receipt-transcation-details-row-value">
          <p>#{{ orderNo }}</p>
        </div>
      </div>
      <div
        v-if="paymentInfo.cardBrand"
        class="receipt-transcation-details-row"
      >
        <div class="receipt-transcation-details-row-title">
          <p>{{ paymentInfo.cardBrand }}</p>
        </div>
        <div
          v-if="paymentInfo.cardLast4"
          class="receipt-transcation-details-row-value"
        >
          <p>•••• {{ paymentInfo.cardLast4 }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ReceiptTransactionDetails",
  props: {
    paymentInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    orderNo() {
      return this.paymentInfo.orderNo.split("# ").pop();
    },
    created() {
      return moment(this.paymentInfo.created).format("DD MMM YYYY");
    },
  },
  filters: {
    formatDate(value) {
      return moment(value).format("DD MMM YYYY");
    },
  },
};
</script>

<style lang="scss">
.transaction-details-dialog {
  .el-dialog {
    width: 480px;
    max-width: calc(100% - 32px);
  }
}

.transaction-details-button {
    margin: 0 auto;
  }
</style>

<style lang="scss" scoped>
.receipt-transcation-details {
  display: flex;
  justify-content: center;

  &-row {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    &:last-child {
      margin-bottom: 24px;
    }

    &-title {
      color: #b5b5b5;
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      line-height: 24px;
      text-transform: capitalize;
    }

    &-value {
      color: #2d2e2f;
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      line-height: 24px;
      font-feature-settings: "pnum" on, "lnum" on;
    }
  }
}
</style>
